var map = {
	"./buddy_controller.js": 21,
	"./chat_controller.js": 22,
	"./demovideo_controller.js": 23,
	"./emoji_controller.js": 24,
	"./file_controller.js": 26,
	"./isTyping_controller.js": 27,
	"./lazy_controller.js": 28,
	"./mobileMenu_controller.js": 29,
	"./navbar_controller.js": 30,
	"./notification_controller.js": 31,
	"./prechat_controller.js": 32,
	"./public_controller.js": 33,
	"./setting_controller.js": 34,
	"./studentRightSidebar_controller.js": 35,
	"./studentSidebar_controller.js": 36,
	"./teacherProfileUpdate_controller.js": 37,
	"./timer_controller.js": 38,
	"./utility_controller.js": 39
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20;